import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Button from 'Components/UI/Button';
import SplitView from 'Components/UI/SplitView';
import SplitViewDescription from 'Components/UI/SplitView/Description';
import { useLayoutContext } from 'Context/LayoutContext';
import SplitViewContent from 'Components/UI/SplitView/Content';

import FlowProgress from './FlowProgress';
import FlowNavigator from './FlowNavigator';
import FlowStep from './FlowStep';
import { useFlowContext } from './FlowContext';

const styles = theme => ({
  root: {},
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  goBackButton: {
    marginRight: theme.spacing(4),
  },
  [theme.breakpoints.down('md')]: {
    goBackButton: {
      marginRight: 0,
    },
  },
});

const FlowView = ({
  className,
  classes,
}) => {
  const { focusedLayout, unfocusedLayout } = useLayoutContext();
  const {
    flowCollection,
    currentStepNumber,
    totalSteps,
    leaveFlow,
  } = useFlowContext();

  useEffect(() => {
    focusedLayout();
    return () => {
      unfocusedLayout();
    };
  }, []);

  const [flowResource] = flowCollection;

  return (
    <SplitView
      className={classNames(classes.root, className)}
      description={
        <SplitViewDescription
          title={flowResource.attr('name')}
          subtitle={flowResource.attr('description')}
        >
          <Button
            className={classes.goBackButton}
            startIcon={<ChevronLeftIcon color="primary" />}
            color="primaryGray"
            onClick={() => {
              leaveFlow();
            }}
            variant="text"
          >
            {'Select a Different Goal'}
          </Button>
        </SplitViewDescription>
      }
    >
      <SplitViewContent className={classes.content}>
        <FlowProgress
          currentStep={currentStepNumber}
          totalSteps={totalSteps}
        />
        <FlowStep />
        <FlowNavigator />
      </SplitViewContent>
    </SplitView>
  );
};

FlowView.defaultProps = {
  className: '',
};

FlowView.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FlowView);
